import WorkerOnBoardingContainer from '@/portal/worker-on-boarding/worker-on-boarding-container/WorkerOnBoardingContainer.vue';

import AccessRequestSent from '@/portal/worker-on-boarding/access-request-sent/AccessRequestSent.vue';
import BusinessSearch from '@/portal/worker-on-boarding/business-search/BusinessSearch.vue';
import InvitationsSent from '@/portal/worker-on-boarding/invitations-sent/InvitationsSent.vue';
import RequestAccess from '@/portal/worker-on-boarding/request-access/RequestAccess.vue';
import SendInvitations from '@/portal/worker-on-boarding/send-invitations/SendInvitations.vue';
import UnregisteredBusiness from '@/portal/worker-on-boarding/unregistered-business/UnregisteredBusiness.vue';
import EmailReminderSent from '@/portal/worker-on-boarding/email-reminder-sent/EmailReminderSent.vue';

import workerOnBoardingGuards from '@/portal/worker-on-boarding/worker-on-boarding.guards';

export default [
  {
    path: '/worker-on-boarding',
    component: WorkerOnBoardingContainer,
    meta: {
      guards: [
        workerOnBoardingGuards.hasOneTimePass,
        workerOnBoardingGuards.workerCreated,
      ],
    },
    redirect: {
      name: 'workerOnBoardingBusinessSearch',
    },
    children: [
      {
        path: 'business-search',
        name: 'workerOnBoardingBusinessSearch',
        component: BusinessSearch,
        meta: {
          guards: [workerOnBoardingGuards.workerNotOnBoarded],
          title: 'Business Search',
        },
      },
      {
        path: 'request-access',
        name: 'workerOnBoardingRequestAccess',
        component: RequestAccess,
        meta: {
          guards: [
            workerOnBoardingGuards.existingBusinessSelected,
            workerOnBoardingGuards.workerNotOnBoarded,
          ],
          title: 'Request Access',
        },
      },
      {
        path: 'access-request-sent',
        name: 'workerOnBoardingAccessRequestSent',
        component: AccessRequestSent,
        meta: {
          guards: [workerOnBoardingGuards.existingBusinessSelected],
          title: 'Request Access Success',
        },
      },
      {
        path: 'invitations-sent',
        name: 'workerOnBoardingInvitationsSent',
        component: InvitationsSent,
        meta: {
          guards: [workerOnBoardingGuards.businessSelected],
          title: 'Invite a Colleague Success',
        },
      },
      {
        path: 'send-invitations',
        name: 'workerOnBoardingSendInvitations',
        component: SendInvitations,
        meta: {
          guards: [
            workerOnBoardingGuards.businessSelected,
            workerOnBoardingGuards.workerNotOnBoarded,
          ],
          title: 'Invite a Colleague',
        },
      },
      {
        path: 'unregistered',
        name: 'workerOnBoardingUnregisteredBusiness',
        component: UnregisteredBusiness,
        meta: {
          guards: [
            workerOnBoardingGuards.businessSelected,
            workerOnBoardingGuards.workerNotOnBoarded,
          ],
          title: 'Business Not Registered',
        },
      },
      {
        path: 'email-reminder-sent',
        name: 'workerOnBoardingEmailReminderSent',
        component: EmailReminderSent,
        meta: {
          guards: [workerOnBoardingGuards.businessSelected],
          title: 'Remind Me Later Success',
        },
      },
    ],
  },
];
